import React, { useEffect, useRef, useState } from "react";
import {useLocaleContext} from "../../../context/LocaleContext";
import { ArrowDown as ArrowDownIcon } from "../../Icons/IconPackage/ArrowDown";
import "./style.scss";

const Filters = ({ filterValues, currentValue, changeFilter }) => {
    const {get: getLocale} = useLocaleContext();
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("click", handleClickOutside);

        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        let currentFilter = filterValues.find(({value}) => value === currentValue);
        if (!currentFilter) {
            changeFilter(filterValues.find(({isDefault}) => isDefault)?.value ?? filterValues[0]?.value);
        }
    }, []);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const onChangeFilter = (value) => {
        changeFilter(value);
        toggleDropdown();
    };

    const className = "messages-filters";

    const currentFilter = filterValues.find( (filter) => filter.value === currentValue);

    return (
        <div className={className} ref={dropdownRef}>
            <div
                className={`${className}--trigger ${isOpen ? "-open" : ""}`}
                onClick={toggleDropdown}
            >
                {getLocale(currentFilter?.label)}
                <ArrowDownIcon />
            </div>
            {isOpen && (
                <div className={`${className}--options`}>
                    {filterValues.map((item) => {
                        const isActive = item.value === currentValue;

                        return (
                            <div
                                key={item.value}
                                className={`${className}--option ${isActive ? "-active" : ""}`}
                                onClick={() => onChangeFilter(item.value)}
                            >
                                {getLocale(item.label)}
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default React.memo(Filters);
